// This is just here as a temporary mid-point in refactoring.
// After the TailWind config has been confirmed to work, references to this
// can be pointed to src/tailwind.config.js directly.

import tailwindConfig from './tailwind.config'

const { theme } = tailwindConfig
export default theme
